import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.25 2.5C5.56 2.5 5 3.06 5 3.75V17.5a.833.833 0 0 0 1.667 0v-6.667h8.75c.858 0 1.348-.98.833-1.666l-1.875-2.5 1.875-2.5a1.042 1.042 0 0 0-.833-1.667zm.417 6.667v-5h7.5l-1.313 1.75a1.25 1.25 0 0 0 0 1.5l1.313 1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }